import React from 'react';
import { Box, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import SubTitleTemplate from '../../common/template/SubTitleTemplate';
import TechCustView from './TechCustView';
import TechReqDetailView from './TechReqDetailView';
import TechUsersView from './TechUsersView';
import TechProductList from './TechProductList';
import * as techApi from '../../../lib/api/tech';
import { viewTech } from '../../../modules/projectModule/tech';
import { listProjectTechs } from '../../../modules/projectModule/projectTechs';

const TechReqView = ({ project, tech }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const onTechConfirm = async () => {
    let dataToSubmit = {
      reqUuid: tech.reqUuid,
      prjUuid: project.prjUuid,
      reqStatus: '지원확인',
      reqGrade: 2,
    }

    try {
      const res = await techApi.editTechReq(dataToSubmit);

      if (res.data.info) {
        dispatch(viewTech(res.data.info.reqUuid));
        dispatch(listProjectTechs(tech.prjUuid));
      }
      enqueueSnackbar('기술 지원 확인', {
        variant: 'success',
      });
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  }

  return (
    <Box>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        py: 2,
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`
      }}>
        <Box>
          {tech.reqGrade === "1" && (
            <Button
              type="button"
              color="info"
              variant="outlined"
              onClick={onTechConfirm}
            >
              지원확인
            </Button>
          )}
        </Box>
        <Box sx={{ flex: '1 1 auto' }} />

      </Box>
      <SubTitleTemplate title="고객 정보">
        <TechCustView tech={tech} />
      </SubTitleTemplate>
      <SubTitleTemplate title="기술 지원 요청 내역">
        <TechReqDetailView tech={tech} />
      </SubTitleTemplate>
      <SubTitleTemplate title="작업자">
        <TechUsersView tech={tech} />
      </SubTitleTemplate>
      <SubTitleTemplate title="공급 제품 리스트">
        <TechProductList tech={tech} />
      </SubTitleTemplate>

    </Box>
  );
};

export default TechReqView;
